import Component from './Component';

export default class TagManagerComponent extends Component {
    get SELECTORS() {
        return {
            hitLink: '.searchbox-results__content .js-article a',
            searchPreviewInput: 'searchboxForm',
            quantity: '.js-quantity',
            product: '.js-article',
            buyOptionId: '#dropdownProductThickness-',
            weightChoiceId: '#dropdownProductWeight-'
        }
    }

    get DATA() {
        return {
            page: 'data-page',
            code: 'data-code',
            name: 'data-name',
            brand: 'data-brand',
            isCategory: 'data-iscategorypage',
            categoryPage: 'data-categorypage',
            discountPrice: 'data-discountPrice',
            url: 'data-gtm-url',
            category1: 'data-gtm-category1',
            category2: 'data-gtm-category2',
            category3: 'data-gtm-category3',
            price: 'data-price',
            gtmList: 'data-gtm-list',
            options: 'data-options',
            pricePerUnit: 'data-priceperunit',
        }
    }

    get PAGES() {
        return {
            wishlist: 'wishlist',
            orders: 'orders',
            listing: 'listing',
            search: 'search',
            pdp: 'product',
            cart: 'cart',
            minicart: 'minicart',
            checkout: 'checkout'
        }
    }

    constructor() {
        super();
    }

    async dataLayerImpressionsGA4(data, isCarousel = false) {
        let layer = [];

        for(let i = 0; i < data.results.length; i++){
            let productOptions = '', category = '';

            if(data.results[i].discount) {
                return;
            }

            if (!!data.results[i].weightChoices && !!data.results[i].buyOptions && data.results[i].weightChoices.length > 0 && data.results[i].buyOptions.length > 0) {
                productOptions = data.results[i].weightChoices[0].size + data.results[i].weightChoices[0].unit + ',' + data.results[i].buyOptions[0].value;
            } else if (!!data.results[i].weightChoices && data.results[i].weightChoices.length > 0) {
                productOptions = data.results[i].weightChoices[0].size + data.results[i].weightChoices[0].unit;
            } else if (!!data.results[i].buyOptions && data.results[i].buyOptions.length > 0) {
                productOptions = data.results[i].buyOptions[0].value;
            }

            layer.push({
                'item_id': data.results[i].code,
                'item_name': data.results[i].summary,
                'coupon': '',
                'currency': 'EUR',
                'discount': Number((!!data.results[i].price.discountPrice) ? (data.results[i].price.value - data.results[i].price.discountPrice) : '0.00'),
                'index': Number(!!data.pagination ? (i + (data.pagination.pageSize * data.pagination.currentPage)) : i),
                'item_brand': !!data.results[i].brand ? data.results[i].brand : '',
                'item_category': data.results[i].breadcrumbs[0].name,
                'item_category2': data.results[i].breadcrumbs[1].name,
                'item_category3': data.results[i].breadcrumbs[2].name,
                'item_list_id': (data.freeTextSearch ? ((isCarousel) ? data.freeTextSearch.trim().toLowerCase() : ('search-' + data.freeTextSearch).trim().toLowerCase()) : category).replaceAll(' ', '_'),
                'item_list_name': data.freeTextSearch ? ((isCarousel) ? data.freeTextSearch.trim().toLowerCase() : ('search-' + data.freeTextSearch).trim().toLowerCase()) : category,
                'item_variant': productOptions,
                'price': Number((!!data.results[i].price.discountPrice) ? data.results[i].price.discountPrice : data.results[i].price.value),
                'quantity': ''
            });
        }

        if(!!parent.dataLayer){
            parent.dataLayer.push({ ecommerce: null });
            parent.dataLayer.push({
                'event': 'view_item_list',
                'ecommerce': {
                    'items': layer
                }
            });
        }
    }

    async FFDataLayerImpressionGA4(data, isCarousel = false) {
        let layer = [];

        data.hits.forEach((hit) => {
            const values = hit.masterValues;
            let productOptions = '', category = '';

            if (!!values.weightChoices && !!values.buyOptions && values.weightChoices.length > 0 && values.buyOptions.length > 0) {
                productOptions = values.weightChoices[0].size + values.weightChoices[0].unit + ',' + values.buyOptions[0].value;
            } else if (!!values.weightChoices && values.weightChoices.length > 0) {
                productOptions = values.weightChoices[0].size + values.weightChoices[0].unit;
            } else if (!!values.buyOptions && values.buyOptions.length > 0) {
                productOptions = values.buyOptions[0].value;
            }

            const product = document.getElementById(values.MasterProductNumber);
            const isCategoryPage = product ? product.getAttribute(this.DATA.isCategory) === 'true' : false;
            category = isCategoryPage ? product.getAttribute(this.DATA.categoryPage) : '';

            let item_list_id = '';
            let item_list_name = '';

            if (isCategoryPage && category) {
                item_list_id = this.slugify(category);
                item_list_name = category;
            } else if (values.query) {
                const q = values.query.trim();
                item_list_id = `search-${this.slugify(q)}`;
                item_list_name = `search-${q}`;
            } else {
                item_list_id = 'listing';
                item_list_name = 'listing';
            }

            layer.push({
                'item_id': values.MasterProductNumber,
                'item_name': values.summary,
                'coupon': '',
                'currency': 'EUR',
                'discount': Number((!!values.cutPrice) ? (values.Price - values.cutPrice) : '0.00'),
                'index': hit.position,
                'item_brand': !!values.brand ? values.brand : '',
                'item_category': values.breadcrumbs[0].name,
                'item_category2': values.breadcrumbs[1].name,
                'item_category3': values.breadcrumbs[2].name,
                'item_variant': productOptions,
                'item_list_id': item_list_id,
                'item_list_name': item_list_name,
                'price': Number((!!values.cutPrice) ? values.cutPrice : values.Price),
                'quantity': ''
            });
        });

        if (!!parent.dataLayer) {
            parent.dataLayer.push({ecommerce: null});
            parent.dataLayer.push({
                'event': 'view_item_list',
                'ecommerce': {
                    'items': layer
                }
            });
        }
    }

    createProductOptions(product) {
        let textWeightChoice, textBuyOption,
        elementWeightChoice = product.querySelector(this.SELECTORS.weightChoiceId + product.getAttribute(this.DATA.code)),
        elementBuyOption = product.querySelector(this.SELECTORS.buyOptionId + product.getAttribute(this.DATA.code));

        if (!!elementWeightChoice) {
            textWeightChoice = elementWeightChoice.tagName === 'SELECT' ? ((elementWeightChoice.selectedIndex != 0) ? elementWeightChoice.options[elementWeightChoice.selectedIndex].textContent.trim() : 'Scegli...') : elementWeightChoice.previousElementSibling.textContent.trim();
            textWeightChoice = textWeightChoice.split('-').length > 1 ? textWeightChoice.split('-')[0] : textWeightChoice
            textWeightChoice = textWeightChoice.search(/\s/g) >= 0 ? textWeightChoice.replace(/\s/g, '') : textWeightChoice
        }
        if (!!elementBuyOption) {
            textBuyOption = elementBuyOption.tagName === 'SELECT' ? elementBuyOption.options[elementBuyOption.selectedIndex].textContent.trim() : elementBuyOption.previousElementSibling.textContent.trim();
        }

        return (!!textWeightChoice) ? ((!!textBuyOption) ? (textWeightChoice + ',' + textBuyOption) : textWeightChoice) : ((!!textBuyOption) ? textBuyOption : '')
    }

    createObjGA4(products, event, isRemoveAll = false) {
        let layer = [], quantity = '';

        for(let i = 0; i < products.length; i++) {

            switch (event) {
                case 'add_to_cart':
                    quantity = (products[i].getAttribute(this.DATA.page) === this.PAGES.wishlist || products[i].getAttribute(this.DATA.page) === this.PAGES.orders) ? Number(products[i].querySelector(this.SELECTORS.quantity).textContent) : 1;
                    break;
                case 'view_item':
                    quantity = (!!products[i].querySelector(this.SELECTORS.quantity)) ? Number(products[i].querySelector(this.SELECTORS.quantity).textContent) : '';
                    break;
                case 'remove_from_cart':
                    quantity = (isRemoveAll) ? ((!!products[i].querySelector(this.SELECTORS.quantity)) ? Number(products[i].querySelector(this.SELECTORS.quantity).textContent) : 1) : 1;
                    break;
                case 'add_to_wishlist':
                    quantity = (!!products[i].querySelector(this.SELECTORS.quantity)) ? Number(products[i].querySelector(this.SELECTORS.quantity).textContent) : 1;
                    break;
            }

            layer.push({
                'item_id': products[i].getAttribute(this.DATA.code), //Codice interno prodotto o SKU
                'item_name': products[i].getAttribute(this.DATA.name), //Nome prodotto
                'coupon': '',
                'currency': 'EUR',
                'discount': Number((!!products[i].getAttribute(this.DATA.discountPrice)) ? (products[i].getAttribute(this.DATA.price) - products[i].getAttribute(this.DATA.discountPrice)).toFixed(2) : '0.00'),
                'index': 0,
                'item_brand': (products[i].getAttribute(this.DATA.brand) != null) ? products[i].getAttribute(this.DATA.brand) : '', //Brand prodotto
                'item_category': products[i].getAttribute(this.DATA.category1),
                'item_category2': products[i].getAttribute(this.DATA.category2),
                'item_category3': products[i].getAttribute(this.DATA.category3),
                'item_list_id': products[i].getAttribute(this.DATA.gtmList).replaceAll(' ', '_'),
                'item_list_name': products[i].getAttribute(this.DATA.gtmList),
                'item_variant': this.createProductOptions(products[i]),
                'price': this.createPrice(products[i], event),
                'quantity': quantity
            });
        }

        return layer
    }

    createPrice(product, event) {
        let finalPrice = 0;
        const isWeightChoice = product
            .getAttribute(this.DATA.options)
            ?.includes('hasWeightChoices');
        const isAddToCart = event === 'add_to_cart';

        if (isWeightChoice && isAddToCart) {
            const pricePerUnit = parseFloat(product.getAttribute(this.DATA.pricePerUnit));
            const weight = parseInt(this.createProductOptions(product).match(/\d+/)[0], 10);
            const weightInKg = weight / 1000;
            const totalPrice = pricePerUnit * weightInKg;
            finalPrice = parseFloat(totalPrice.toFixed(2));
        } else {
            finalPrice = Number(product.getAttribute(this.DATA.discountPrice)) ||
                Number(product.getAttribute(this.DATA.price));
        }
        return finalPrice;
    }

    dataLayerAddToCartGA4(products) {
        let obj = this.createObjGA4(products, 'add_to_cart');

        parent.dataLayer.push({ ecommerce: null });
        parent.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'items': obj
            }
        });

        switch (products[0].getAttribute(this.DATA.page)) {
            case this.PAGES.listing:
                if (window.location.pathname === '/cart') {
                    this.dataLayerOnEvent(obj.productsName, 'Cart', 'add_to_cart');
                } else {
                    this.dataLayerOnEvent(obj.productsName, 'Listing', 'add_to_cart');
                }
                break;
            case this.PAGES.search:
                this.dataLayerOnEvent(obj.productsName, 'Search', 'add_to_cart');
                break;
            case this.PAGES.pdp:
                this.dataLayerOnEvent(obj.productsName, 'Scheda Prodotto', 'add_to_cart');
                break;
            case this.PAGES.cart:
            case this.PAGES.minicart:
                this.dataLayerOnEvent(obj.productsName, 'Cart', 'add_to_cart');
                break;
        }
    }

    dataLayerViewItemGA4(product) {
        let obj = this.createObjGA4([product], 'view_item');

        parent.dataLayer.push({ ecommerce: null });
        parent.dataLayer.push({
            'event': 'view_item',
            'view_type': (product.getAttribute(this.DATA.page) === this.PAGES.pdp) ? 'pdp' : 'list',
            'ecommerce': {
                'items': obj
            }
        });
    }

    dataLayerRemoveFromCartGA4(products, removeAllProducts = false) {
        let obj = this.createObjGA4(products, 'remove_from_cart', removeAllProducts);

        parent.dataLayer.push({ ecommerce: null });
        parent.dataLayer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
                'items': obj
            }
        });
    }

    dataLayerAddToWishlistGA4(products) {
        let obj = this.createObjGA4(products, 'add_to_wishlist');

        parent.dataLayer.push({ ecommerce: null });
        parent.dataLayer.push({
            'event': 'add_to_wishlist',
            'ecommerce': {
                'items': obj
            }
        });
    }

    dataLayerOnEvent(name, page, action) {
        parent.dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : action,
            'eventAction' : page,
            'eventlabel' : name //Nome prodotto aggiunto
        });
    }

    slugify(s) {
        if (!s) return '';
        return s
            .toString()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    bindEvents() {
        const searchPreviewInput = document.getElementById(this.SELECTORS.searchPreviewInput);

        if (searchPreviewInput != null) {
            searchPreviewInput.addEventListener('submit', (e)=>{
                this.dataLayerOnEvent(document.getElementById(this.SELECTORS.searchPreviewInput).querySelector('input').value, 'Ricerca Personalizzata', 'Internal Search');
            });

            this.events.on('click', this.SELECTORS.hitLink, (e) => {
                this.dataLayerOnEvent(e.target.closest(this.SELECTORS.product).getAttribute(this.DATA.name), 'Prodotti Consigliati', 'Internal Search');
            });
        }
    }

    render() {
        this.log('render Tag Manager');
        this.bindEvents();
    }
}
